import { useState } from "react";
import "./pricingcalendar.css";
import OffersCalendar from "./OffersCalendar";
import RateCalendar from "./RateCalendar";

const TABS = [
  {
    key: 0,
    label: "Rate calendar",
    hint: "Occupancy-based pricing rules",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" />
      </svg>
    ),
  },
  {
    key: 1,
    label: "Offers calendar",
    hint: "Promotional windows & campaigns",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
        <line x1="7" y1="7" x2="7.01" y2="7" />
      </svg>
    ),
  },
];

const PricingCalendar = () => {
  const [selectedCalendar, setSelectedCalendar] = useState(0);

  return (
    <div className="pc">
      <header className="pc-hero">
        <div>
          <span className="pc-hero__eyebrow">Revenue management</span>
          <h1 className="pc-hero__title">Pricing calendars</h1>
          <p className="pc-hero__sub">
            Manage how rates react to occupancy and schedule promotional offers across the year.
          </p>
        </div>
      </header>

      <div className="pc-tabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.key}
            role="tab"
            aria-selected={selectedCalendar === t.key}
            className={`pc-tab ${selectedCalendar === t.key ? "is-active" : ""}`}
            onClick={() => setSelectedCalendar(t.key)}
          >
            <span className="pc-tab__icon">{t.icon}</span>
            <span className="pc-tab__body">
              <span className="pc-tab__label">{t.label}</span>
              <span className="pc-tab__hint">{t.hint}</span>
            </span>
          </button>
        ))}
      </div>

      <div className="pc-panel">
        {selectedCalendar === 0 ? <RateCalendar /> : <OffersCalendar />}
      </div>
    </div>
  );
};

export default PricingCalendar;
